import {Locale} from '.';
import {DEFAULT_LOCALE, LOCALES} from './locales';

export const parseLocale = (locale?: string): Locale => {
  if (!locale || !LOCALES[locale as Locale]) {
    return DEFAULT_LOCALE;
  }

  return locale as Locale;
};
